export const SITE_URL = "https://eschool.et";
export const SITE_NAME = "eSchool Ethiopia";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.jpg`;

const routeLabels: Record<string, string> = {
  "/": "Home",
  "/platform": "Platform",
  "/features": "Features",
  "/admin-dashboard": "Admin Dashboard",
  "/teacher-app": "Teacher App",
  "/parent-app": "Parent App",
  "/student-app": "Student App",
  "/pricing": "Pricing",
  "/about": "About",
  "/contact": "Contact",
  "/school-management-system-ethiopia": "School Management System Ethiopia",
  "/school-management-in-addis-ababa": "School Management in Addis Ababa",
  "/multi-institute-system-addis-ababa": "Multi Institute System Addis Ababa",
  "/register-school": "2019 E.C. School Onboarding",
  "/blog": "Blog",
  "/sitemap": "Sitemap",
  "/privacy-policy": "Privacy Policy",
  "/terms-and-conditions": "Terms and Conditions",
};

export interface BreadcrumbEntry {
  name: string;
  path: string;
}

export const normalizePath = (pathname: string) => {
  const withLeadingSlash = pathname.startsWith("/") ? pathname : `/${pathname}`;
  const collapsed = withLeadingSlash.replace(/\/{2,}/g, "/");

  return collapsed.length > 1 ? collapsed.replace(/\/+$/, "") : collapsed;
};

export const getCanonicalUrl = (pathname: string) => {
  const path = normalizePath(pathname);
  return path === "/" ? `${SITE_URL}/` : `${SITE_URL}${path}`;
};

const titleCaseSegment = (segment: string) =>
  segment
    .split("-")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const getBreadcrumbs = (
  pathname: string,
  currentLabel?: string,
): BreadcrumbEntry[] => {
  const path = normalizePath(pathname);

  if (path === "/") {
    return [{ name: "Home", path: "/" }];
  }

  const segments = path.split("/").filter(Boolean);
  const entries: BreadcrumbEntry[] = [{ name: "Home", path: "/" }];

  segments.forEach((segment, index) => {
    const segmentPath = `/${segments.slice(0, index + 1).join("/")}`;
    const isLast = index === segments.length - 1;

    entries.push({
      name: isLast && currentLabel
        ? currentLabel
        : routeLabels[segmentPath] ?? titleCaseSegment(segment),
      path: segmentPath,
    });
  });

  return entries;
};
